// @docs:
//   - docs/wip/CREW_PAPER_REQUESTS.md  § Crew sign-in (papers-only account)
// ==============================================
// /dashboard (index). Everyone lands on the MyPolaris dashboard as before,
// except a papers-only account — crew who came in through a request link and
// have no plan, vessel, subscription or device — who goes to /papers instead
// of plan and device pages that mean nothing to them. isPapersOnly holds the
// rule; if any check fails, the dashboard is shown (the old behaviour).
// ==============================================

import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../services/api';
import { DashboardPage } from '../../../pages/dashboard/DashboardPage';
import { isPapersOnly } from '../papersOnly';

export function DashboardHome() {
  const access = useQuery({ queryKey: ['papers-me', 'access'], queryFn: () => api.papersMeAccess(), retry: false, staleTime: 60_000 });
  const usage = useQuery({ queryKey: ['usage'], queryFn: () => api.getMyUsage(), retry: false });
  // Only asked when it could change the answer: no plan, no vessel, no open request.
  const maybe = !!access.data && !access.data.hasPlan && access.data.vesselCount === 0 && access.data.recipientRequests === 0
    && !!usage.data && !usage.data.package && !usage.data.subscription && !(usage.data.device_count ?? 0);
  const mine = useQuery({ queryKey: ['papers-me', 'documents'], queryFn: () => api.papersMyPapers(), enabled: maybe, retry: false });

  if (access.isLoading || usage.isLoading || (maybe && mine.isLoading)) {
    return (
      <div className="flex justify-center py-16" role="status" aria-label="Loading">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-cyan-500 border-t-transparent" />
      </div>
    );
  }
  if (isPapersOnly({ access: access.data, usage: usage.data, myPaperCount: mine.data?.length ?? 0 })) return <Navigate to="/papers" replace />;
  return <DashboardPage />;
}

export default DashboardHome;
